import ApiServices from "@/api/apexchat.api.services";
import { AnalyticAPI, general } from "@/api/endpoints";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activities: [],
  skip: 0,
  isActivtyLogSubscribed: false,
};

export const activitySlice = createSlice({
  name: "activities",
  initialState: { ...initialState },

  reducers: {
    /**
     * @name @setActivitiesToState
     * @description set activities to state
     **/
    setActivitiesToState: (state, action) => {
      state.activities = action?.payload;
    },
    appendActivities: (state, action) => {
      const newActivities = action?.payload.filter(
        (newActivity) =>
          !state.activities.some((existing) => existing.id === newActivity.id)
      );
      state.activities = [...state.activities, ...newActivities];
    },
    setSkipToState: (state, action) => {
      state.skip = action?.payload;
    },
    /**
     * @name @setActivityToState
     * @description set an activity to state
     **/
    setActivityToState: (state, action) => {
      const activitiesState = JSON.parse(JSON.stringify(state.activities));
      activitiesState.unshift(action.payload);
      state.activities = [...activitiesState];
    },
  },
});

export const {
  setActivitiesToState,
  setActivityToState,
  appendActivities,
  setSkipToState,
  setActivityOnSubscribed,
} = activitySlice.actions;

export const getActivities = (state) => {
  return state.activity?.activities;
};

export const getSkipCount = (state) => {
  return state.activity?.skip;
};

export default activitySlice.reducer;
